/* vn-soldout-lite.js — 価格DOMは書き換えず、[data-block-type="price"] を常時ターゲット
   ・在庫0の間は「SOLD OUTロック」＝インラインCSSも保持（チラ見え防止）
   ・見た目は price の計算値をコピー（色/サイズ/太さ/書体/字間/行高）
   ・デスクトップ=左、モバイル(<=749px)=中央
*/
(function () {
  if (window.VNS_SOLDOUT_BOOTED) return; window.VNS_SOLDOUT_BOOTED = true;

  var LABEL = window.VNS_SOLDOUT_LABEL || 'SOLD OUT';
  var productCache = Object.create(null);

  // ---- 永続CSS（body.vns-sold が付いている間は常に効く） ----
  (function injectCSS(){
    if (document.getElementById('vns-soldout-css')) return;
    var css = document.createElement('style'); css.id = 'vns-soldout-css';
    css.textContent = [
      'body.vns-sold [data-block-type="price"]{position:relative;text-align:left !important;}',
      '@media (max-width:749px){body.vns-sold [data-block-type="price"]{text-align:center !important;}}',
      'body.vns-sold [data-block-type="price"] *{visibility:hidden !important;}',
      'body.vns-sold [data-block-type="price"]::after{',
      '  content:', JSON.stringify(LABEL), ';',
      '  visibility:visible;',
      '  color: var(--vns-color, #303030A6);',
      '  font-size: var(--vns-size, 14.4px);',
      '  font-weight: var(--vns-weight, inherit);',
      '  font-family: var(--vns-family, inherit);',
      '  letter-spacing: var(--vns-letter, normal);',
      '  line-height: var(--vns-lh, normal);',
      '}'
    ].join('');
    document.head.appendChild(css);
  })();

  // ---- 商品メタ ----
  function parseThemeJSON(){
    var variants = [], available = true, handle = null;
    var js = document.querySelector('script[type="application/json"][data-product], script[type="application/json"][data-product-json]');
    if (js){ try{ var d=JSON.parse(js.textContent||'{}'); variants=d.variants||[]; available=(typeof d.available==='boolean')?d.available:true; handle=d.handle||null; }catch(e){} }
    if (!handle && window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product){
      var p = ShopifyAnalytics.meta.product;
      if (!variants.length) variants = p.variants || [];
      if (typeof p.available==='boolean') available = p.available;
      handle = p.handle || handle;
    }
    if (!handle){ var meta=document.getElementById('vns-soldout-meta'); if (meta) handle = meta.getAttribute('data-handle') || handle; }
    return { variants: variants, available: available, handle: handle };
  }

  function selectedVariant(variants){
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form');
    var idEl = form && (form.querySelector('select[name="id"], input[name="id"]'));
    var id = idEl ? parseInt(idEl.value,10) : null;
    if (!id) return null;
    for (var i=0;i<variants.length;i++){ var v=variants[i]; if (v && v.id===id) return v; }
    return null;
  }

  // 判定：在庫0なら true、在庫ありなら false、数量不明なら null（＝解除しない）
  function soldOutState(v, productAvailable){
    if (productAvailable === false) return true;
    if (!v) return null;                       // 不明な瞬間は解除しない
    if (v.available === false) return true;
    var tracks = !!v.inventory_management;
    if (!tracks) return false;
    if (typeof v.inventory_quantity !== 'number') return null;
    return v.inventory_quantity <= 0;
  }

  // 初期インラインCSSが出ていれば「SOLD OUTロック」ON
  var lockSold = !!document.getElementById('vns-inline-soldout');
  var clearTimer = null;

  function setSold(flag){
    document.body.classList.toggle('vns-sold', !!flag);
    // 在庫ありに「確定」した時だけ、インラインCSSを外してロック解除
    if (!flag) {
      var s = document.getElementById('vns-inline-soldout');
      if (s && s.parentNode) s.parentNode.removeChild(s);
      lockSold = false;
    }
  }

  // price の見た目をホストにコピー（CSSカスタムプロパティ）
  function syncTypography(host){
    if (!host) return;
    var priceEl = host.querySelector('sale-price') ||
                  host.querySelector('regular-price') ||
                  host.querySelector('.price, .product__price');
    if (!priceEl) return;
    var cs = window.getComputedStyle(priceEl);
    host.style.setProperty('--vns-color', cs.color);
    host.style.setProperty('--vns-size', cs.fontSize);
    host.style.setProperty('--vns-weight', cs.fontWeight);
    host.style.setProperty('--vns-family', cs.fontFamily);
    host.style.setProperty('--vns-letter', cs.letterSpacing);
    host.style.setProperty('--vns-lh', cs.lineHeight);
  }

  // 在庫あり「確定」時だけ解除（誤検知避けに少しだけ遅延）
  function clearSoldWhenDefinitelyInStock(v){
    var tracks = !!(v && v.inventory_management);
    var definite = v && v.available === true && (!tracks || (typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0));
    if (!definite) return;
    clearTimeout(clearTimer);
    clearTimer = setTimeout(function(){ setSold(false); }, 120);
  }

  function recompute(meta, host){
    // 常に見た目を同期（セール/比較価格でサイズが変わるテーマ対策）
    syncTypography(host);

    var v = meta.variants.length ? selectedVariant(meta.variants) : null;
    var state = soldOutState(v, meta.available);

    if (state === true) { setSold(true); return; }

    if (state === null) {
      if (lockSold) setSold(true); // 不明な間はロックがあれば出しっぱなし
      return;
    }

    // state === false
    clearSoldWhenDefinitelyInStock(v);
  }

  function init(){
    var host = document.querySelector('[data-block-type="price"]');
    if (!host) return; // product ページのみ

    var meta = parseThemeJSON();

    // 初期＆フォント読み込み後に同期
    syncTypography(host);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function(){ syncTypography(host); }); }

    // 初期判定
    recompute(meta, host);

    // 数量未提供なら、必要時のみ /products/{handle}.js を一度だけ補完
    var needQty = meta.variants.length && meta.variants.some(function(v){ return typeof v.inventory_quantity !== 'number'; });
    if (needQty && meta.handle){
      if (productCache[meta.handle]) mergeAndPaint(productCache[meta.handle]);
      else {
        fetch('/products/' + meta.handle + '.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(json){ productCache[meta.handle] = json; mergeAndPaint(json); })
          .catch(function(){ /* 失敗しても現状維持（ロックがあれば出しっぱなし） */ });
      }
    }

    function mergeAndPaint(json){
      if (!json || !json.variants) return;
      var dict = {}; json.variants.forEach(function(v){ dict[v.id]=v; });
      meta.variants = meta.variants.map(function(v){ return Object.assign({}, v, dict[v.id] || {}); });
      recompute(meta, host);
    }

    // バリアント切替・再描画に追従
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form');
    if (form){
      form.addEventListener('change', function(e){
        if (e && (e.target.name==='id' || (e.target.closest && e.target.closest('[name="id"]')))) recompute(meta, host);
      });
    }
    document.addEventListener('variant:change', function(){ recompute(meta, host); });
    document.addEventListener('shopify:section:load', function(){ recompute(meta, host); });

    // price ブロック差し替え時にも再同期
    var mo = new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        var nodes = muts[i].addedNodes || [];
        for (var j=0;j<nodes.length;j++){
          var n = nodes[j];
          if (n.nodeType===1 && (n.matches('[data-block-type="price"]') || (n.closest && n.closest('[data-block-type="price"]')))) {
            host = document.querySelector('[data-block-type="price"]');
            syncTypography(host);
            recompute(meta, host);
            return;
          }
        }
      }
    });
    mo.observe(document.body, {subtree:true, childList:true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
